import { get, post, put, destroy } from "./base";

const CategoryServ = {
  index: (params) => get("/categories", { params }),
  getLifestyleCategories: (params) => get("/categories/lifestyle", { params }),
  single: (id) => get(`/categories/${id}`),
  create: (payload) => post("/categories", payload),
  update: (id, payload) => put(`/categories/${id}`, payload),
  remove: (id) => destroy(`/categories/${id}`),
  uploadImage: (formData) => post("/upload/category", formData)
};

export default CategoryServ;
